<template>
  <div class="main">
    <div id="listview">
      <div v-for="item in items" :key="item.text" class="card">
        <div class="card-body">
          <p class="card-text">
            <span>No.{{ item[0] }}</span>
            <span v-if="item[4] == '0'" class="pull-right text-muted small"><span class="status on">進行中</span></span>
            <span v-if="item[4] == '1'" class="pull-right text-muted small" v-on:click="showDetails(item[0])"><span
                class="status ing">使用する</span></span>
            <span v-if="item[4] == '9'" class="pull-right text-muted small"><span class="status off">使用済</span></span>
            <br>
            開始日：<span v-if="item[1] != 'Invalid date'">{{ item[1] }}</span><br>
            完了日：<span v-if="item[2] != 'Invalid date'">{{ item[2] }}</span><br>
            利用日：<span v-if="item[3] != 'Invalid date'">{{ item[3] }}</span><br>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sx from '../utils/core.js'

// Import jquery
import $ from "jquery";
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $;

export default {
  created() {
    this.$store.state.title = 'スタンプ'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'My'
  },
  data() {
    return {
      items: []
    }
  },
  mounted() {
    sx.showWaiting()
    const that = this

    var params = {
      corpid: 40,
      token: localStorage.getItem('token')
    }
    sx.request(
      that.$store.state.baseurl + '/app/mshelper/fetchStamp',
      params,
      function (result) {
        if (result.status === 'ok') {
          that.items = result.data.rows
          sx.hideWaiting()
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
          sx.hideWaiting()
        }
      },
      function () {
        that.$router.replace({ name: 'Login' })
      }
    )
    sx.hideWaiting()
  },
  methods: {
    showDetails(stampid) {
      this.$router.replace({ name: 'StampDetails', query: { stampid: stampid } })
    }
  }
}
</script>
<style>
#listview {
  margin: 4px;
}

#listview .card {
  text-align: left;
  margin-top: 4px;
}

small {
  color: #fb6e14;
}

.lead {
  padding-top: 20px;
  text-align: left;
  color: #fb6e14;
}

.main {
  padding: 4px;
}

.status {
  height: 34rpx;
  line-height: 34rpx;
  font-size: 9pt;
  width: 300px;
  text-align: center;
  justify-content: center;
  margin-bottom: 10rpx;
  border-radius: 4px;
  padding: 0 10rpx;
  margin-right: 10rpx;
  background: #CCCCCC;
  color: black;
  margin: 2px;
  padding: 4px;
}

.ing {
  background: #FF9966;
  color: white;
}

.on {
  background: #99CC66;
  color: white;
}

.off {
  background: #CCCCCC;
  color: black;
}</style>
